<template>
  <div id="main">
    <router-view />

    <div :style="{ height: h }"></div>
    <div
      class="open-app-bar"
      v-if="clientCode !== 'xsb_iwenling'"
      ref="open_app_bar"
    >
      <div class="left">
        <div class="logo">
          <van-image
            width="40"
            height="40"
            src="https://img.tmuyun.com/assets/20210224/1614167550667_60363dfeb40eef0bde8df5be.png"
          ></van-image>
        </div>
        <div class="info">
          <div class="name">掌上温岭</div>
          <div class="unit">温岭市融媒体中心</div>
        </div>
      </div>
      <div class="right">
        <van-button color="#ff2127" @click="onOpenInApp">打开</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "layout",
  data() {
    return {
      clientCode: "",
      h: "",
    };
  },
  mounted() {
    this.clientCode = this.$clientCode;
    if (this.clientCode !== "xsb_iwenling") {
      this.h = this.$refs.open_app_bar.offsetHeight + "px";
    }
  },
  methods: {
    onOpenInApp() {
      const ob = {
        path: "/notinapp",
        query: {
          redirect: this.$route.fullPath,
        },
      };
      this.$router.push(ob);
    },
  },
};
</script>

<style lang="less" scoped>
.open-app-bar {
  width: 100vw;
  background-color: #efefef;
  position: fixed;
  left: 0;
  bottom: 0;
  padding: 10px 0;
  display: inline-flex;
  justify-content: space-between;
  .left {
    display: flex;
    flex: 0 0 0.5;
    padding-left: 20px;
    .info {
      padding-left: 10px;
      .unit {
        font-size: 12px;
        color: #8e96a9;
      }
    }
  }
  .right {
    padding-right: 20px;
    button {
      padding: 10px 20px;
      font-size: 18px;
    }
  }
}
</style>